<template>
  <v-app class="queue-up">
    <v-container fluid class="queue-up_container">
      <section class="ma-10">
        <router-view/>
      </section>
    </v-container>
  </v-app>
</template>
<script>
export default {
  name: "Queue-Up",
}
</script>
<style type="text/css">
.queue-up_container {
  min-height: 100vh;
  background-color: white;
}
</style>
